import angular from "angular"

import { shouldAttemptTokenRefresh } from "@/identity-token-refresh.js"

angular.module("appModule").factory("identityAuthInterceptor", [
  "$q",
  "$injector",
  "tokenRefreshService",
  function($q, $injector, tokenRefreshService) {
    return {
      responseError: function(rejection) {
        var config = rejection.config

        if (
          rejection.status !== 401 ||
          !tokenRefreshService.isIdentityAuthMode() ||
          !shouldAttemptTokenRefresh(config)
        ) {
          return $q.reject(rejection)
        }

        return tokenRefreshService
          .refreshAccessToken()
          .then(function(token) {
            config._identityRetried = true
            config.headers = config.headers || {}
            config.headers.Authorization = "JWT " + token

            return $injector.get("$http")(config)
          })
          .catch(function(error) {
            return $q.reject(rejection || error)
          })
      }
    }
  }
])
